// src/lib/redux/dailySummary/dailySummarySlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DailySummary } from "@/lib/redux/context";

interface DailySummaryState {
  data: DailySummary | null;
  loading: boolean;
  error: string | null;
}

const initialState: DailySummaryState = {
  data: null,
  loading: false,
  error: null,
};

const dailySummarySlice = createSlice({
  name: "dailySummary",
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
      if (action.payload) state.error = null;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
    setDailySummary(state, action: PayloadAction<DailySummary>) {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchDailySummaryStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchDailySummarySuccess(state, action: PayloadAction<DailySummary>) {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchDailySummaryFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  setLoading,
  setError,
  setDailySummary,
  fetchDailySummaryStart,
  fetchDailySummarySuccess,
  fetchDailySummaryFailure,
} = dailySummarySlice.actions;

export default dailySummarySlice.reducer;